export default __webpack_public_path__ + "static/char-s-34-ja-1d3d306a9b04dc3b70f144784b10daec.png";